import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#f5f4f2] border-t border-gray-200">
      <div className="max-w-6xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/731ba6a5-d861-4514-b45b-3ebef5d11079.png"
              alt="BONIEK Logo"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-sm text-gray-500 leading-relaxed">
              Conseil en gestion et développement d&apos;entreprise.<br />
              Entrepreneur individuel basé à Bordeaux.
            </p>
            <p className="text-xs text-gray-400 mt-3">SIRET : 102 005 980 00010</p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-5">Navigation</h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Accueil', path: '/' },
                { label: 'À propos', path: '/a-propos' },
                { label: 'Contact', path: '/contact' },
                { label: 'Conditions générales', path: '/conditions-generales' },
                { label: 'Politique de confidentialité', path: '/politique-de-confidentialite' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-500 hover:text-[#1a2e4a] transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-5">Contact</h4>
            <ul className="flex flex-col gap-3 text-sm text-gray-500">
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5"><i className="ri-map-pin-line text-[#1a2e4a]"></i></span>
                <span>27 Rue Malbec<br />33800 Bordeaux, France</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-line text-[#1a2e4a]"></i></span>
                <a href="tel:+33751108791" className="hover:text-[#1a2e4a] transition-colors cursor-pointer">+33 7 51 10 87 91</a>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-mail-line text-[#1a2e4a]"></i></span>
                <a href="mailto:dom1n1kaboniek@outlook.com" className="hover:text-[#1a2e4a] transition-colors cursor-pointer break-all">dom1n1kaboniek@outlook.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-400">
          <span>&copy; {new Date().getFullYear()} BONIEK – Dominika Julia Boniek. Tous droits réservés.</span>
          <div className="flex items-center gap-4">
            <Link to="/conditions-generales" className="hover:text-[#1a2e4a] transition-colors cursor-pointer">Conditions générales</Link>
            <Link to="/politique-de-confidentialite" className="hover:text-[#1a2e4a] transition-colors cursor-pointer">Confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
